
import txtConfig from "../../../config/txtConfig";
import sysConfig from "../../../config/sysConfig";
import baseConfig from "../../../config/baseConfig";

var orgCommonList = [{
  title: "营业执照副本或者能够证明机构法人资格的其他材料",
  name: "原件以及复印件（加盖机构公章）"
}, {
  title: "法定代表人有效身份证明文件",
  name: "复印件（加盖机构公章）"
}, {
  title: "法定代表人授权委托书",
  name: "原件（加盖机构公章、法定代表人签章）"
}, {
  title: "经办人有效身份证明文件",
  name: "原件以及复印件（加盖机构公章）"
}];
var personCommonList = [{
  "title": "个人身份证明材料",
  "name": "处于有效期内的身份证/临时身份证/护照/港澳台身份证/港澳台通行证/港澳台居住证/外国人永久居留证 原件及复印件"
}];
var orgRzrqCommonList = [{
  title: "营业执照副本或者能够证明机构法人资格的其他材料",
  name: "复印件（加盖机构公章）"
}, {
  title: "法定代表人有效身份证明文件",
  name: "复印件（加盖机构公章）"
}, {
  title: "融资融券业务授权委托书",
  name: "原件（加盖机构公章、法定代表人签章）"
}, {
  title: "经办人有效身份证明文件",
  name: "原件"
}, {
  title: "公司章程或企业组织文件",
  name: "复印件（加盖机构公章）"
}, {
  title: "允许开展业务的证明材料（股东会决议、董事会决议等",
  name: "原件（加盖机构公章、相关责任人签字）"
}, {
  title: "办公地址证明材料（租赁合同、水电物业缴费凭证等）",
  name: "复印件（加盖机构公章）"
}, {
  title: "财务状况证明材料（一年一期财报）",
  name: "复印件（加盖机构公章）"
}];
var proRzrqCommonList = [{
  title: "营业执照副本或者能够证明机构法人资格的其他材料",
  name: "复印件（加盖机构公章）"
}, {
  title: "法定代表人有效身份证明文件",
  name: "复印件（加盖机构公章）"
}, {
  title: "融资融券业务授权委托书",
  name: "原件（加盖机构公章、法定代表人签章）"
}, {
  title: "经办人有效身份证明文件",
  name: "原件"
}, {
  title: "产品合同",
  name: "复印件（加盖机构公章）"
}, {
  title: "办公地址证明材料（租赁合同、水电物业缴费凭证等）",
  name: "复印件（加盖机构公章）"
}, {
  title: "私募基金产品信息申报表",
  name: "原件（加盖机构公章）"
}, {
  title: "担保材料（保证函）",
  name: "原件（加盖机构公章）"
}, {
  title: "担保材料（担保人身份证明、财力证明、信用记录证明等）",
  name: "复印件（加盖机构公章）"
}];
var personRzrqCommonList = [{
  "title": "有效身份证明文件",
  "name": "原件"
}];
var v0126CommonPages = [{
  name: "资料录入",
  path: "/bizFlow/:busiCode/:userType/bizChangeNavigation",
  show: true,
  nextBtnText: "修改完成",
  isCommit: false
}, {
  name: "资料录入",
  _name: "证件信息",
  path: "/bizFlow/:busiCode/:userType/bizEntry/0",
  show: true,
  group: "ORG_IMPORNTANT_INFO",
  modules: ["ORG_IMPORNTANT_INFO_MODULE"],
  nextBtnText: "保存修改",
  isCommit: true,
  checkFieldChange: true,
  ignorePrev: true
}, {
  name: "资料录入",
  _name: "基础信息",
  path: "/bizFlow/:busiCode/:userType/bizEntry/1",
  show: true,
  group: "ORG_BASIC_INFO",
  modules: ["ORG_BASIC_INFO_MODULE", "ORG_LINK_INFO_MODULE", "ORG_LEGAL_INFO_MODULE", "ORG_RECORD_INFO_MODULE", "ORG_TAX_INFO_MODULE1", "ORG_TAX_INFO_MODULE2", "ORG_TAX_INFO_MODULE3", "ORG_TAX_INFO_MODULE5", "ORG_TAX_INFO_MODULE4", "CONTROLER_TAX_INFO_MODULE"],
  nextBtnText: "保存修改",
  isCommit: true,
  checkFieldChange: true,
  ignorePrev: true,
  mdMaxLen: 99
}, {
  name: "资料录入",
  _name: "其他信息",
  path: "/bizFlow/:busiCode/:userType/bizEntry/2",
  show: true,
  group: "ORG_OTHER_INFO",
  modules: ["ORG_CONTROLER_INFO_1_MODULE", "ORG_PARTNER_INFO_MODULE", "ORG_CONTROLER_INFO_MODULE", "ORG_BENEFIT_INFO_MODULE", "ORG_QUAL_INFO_MODULE", "ORG_BSB_INFO_MODULE", "BANK_SYNC_INFO"],
  nextBtnText: "保存修改",
  isCommit: true,
  checkFieldChange: true,
  ignorePrev: true,
  mdMaxLen: 99
}, {
  name: "资料录入",
  _name: "银证账户信息",
  path: "/bizFlow/:busiCode/:userType/bizEntry/3",
  group: "BANK_SYNC_INFO",
  modules: ["BANK_SYNC_INFO"],
  nextBtnText: "保存修改",
  isCommit: true,
  checkFieldChange: true,
  ignorePrev: true,
  isShowPrev: false,
  show: true
}, {
  name: "资料录入",
  _name: "修改对比",
  path: "/bizFlow/:busiCode/:userType/bizInfoChange",
  show: true,
  ignorePrev: true
}];
var v0127CommonPages = [{
  name: "资料录入",
  path: "/bizFlow/:busiCode/:userType/bizChangeNavigation",
  show: true,
  nextBtnText: "修改完成",
  isCommit: false
}, {
  name: "资料录入",
  _name: "身份信息",
  path: "/bizFlow/:busiCode/:userType/bizEntry/0",
  show: true,
  group: "CUST_INFO",
  modules: ["PRD_IMPORNTANT", "PRD_BASIC", "PRD_BENEFICIARY", "PRD_CONTROLLER", "PRD_REAL_CONTROLLER"],
  nextBtnText: "保存修改",
  isCommit: true,
  checkFieldChange: true,
  ignorePrev: true,
  mdMaxLen: 99
}, {
  name: "资料录入",
  _name: "产品管理人信息",
  path: "/bizFlow/:busiCode/:userType/bizEntry/1",
  show: true,
  group: "MANAGER_INFO",
  modules: ["MA_IMPORNTANT", "MA_BASIC_INFO", "MA_LINK_INFO", "MA_LEGAL_REP", "MA_CONTROLLER", "MA_CORP_QUAL", "MA_CREDIT_RECORD", "MA_CUST_TAX_INFO_MODULE", "MA_CONTROLER_TAX_INFO_MODULE"],
  nextBtnText: "保存修改",
  isCommit: true,
  checkFieldChange: true,
  ignorePrev: true,
  mdMaxLen: 99
}, {
  name: "资料录入",
  _name: "产品其他信息",
  path: "/bizFlow/:busiCode/:userType/bizEntry/2",
  show: true,
  group: "OTHER_INFO",
  modules: ["OT_PRO_TRUSTEE", "OT_CLIENT", "MA_LINK_INFO", "OT_BSB_INFO", "OT_INVEST_ADVISER", "OT_SHAREREG"],
  nextBtnText: "保存修改",
  isCommit: true,
  checkFieldChange: true,
  ignorePrev: true,
  mdMaxLen: 99
}, {
  name: "资料录入",
  _name: "银证账户信息",
  path: "/bizFlow/:busiCode/:userType/bizEntry/3",
  show: true,
  group: "BANK_SYNC_INFO",
  modules: ["BANK_SYNC_INFO"],
  nextBtnText: "保存修改",
  isCommit: true,
  checkFieldChange: true,
  ignorePrev: true,
  isShowPrev: false
}, {
  name: "资料录入",
  _name: "修改对比",
  path: "/bizFlow/:busiCode/:userType/bizInfoChange",
  show: true,
  ignorePrev: true
}];
var qsConfig = {
  GUOTOU: {
    "QS420": {
      open: true,
      pageCount: 20,
      infoList: [{
        "id": "1",
        "type": "ID_TYPE",
        "name": "机构",
        "explain": "本功能适用于为您办理机构客户开户业务",
        "list": orgCommonList.concat([])
      }],
      bizRoutes: [{
        name: "机构信息",
        path: "/bizFlow/:busiCode/:userType/baseInfoNode/bizEntry/10",
        group: "OCR_ORG_INFO_PAGE",
        modules: ["IMPORTANT_MODULE_OCR", "IMPORTANT_MODULE_ZD", "IMPORTANT_MODULE"],
        fromName: "资料录入",
        from: "orgInfo",
        isHideTmpSave: true }, {
        name: "代理人信息",
        path: "/bizFlow/:busiCode/:userType/baseInfoNode/bizEntry/20",
        group: "OCR_AGENT_INFO_PAGE",
        modules: ["AGENT_MODULE_OCR", "AGENT_MODULE"],
        fromName: "智能录入",
        from: "orgInfo" }, {
        name: "基础信息",
        path: "/bizFlow/:busiCode/:userType/baseInfoNode/bizEntry/30",
        group: "ORG_INFO_PAGE",
        modules: ["BASIC_MODULE"],
        fromName: "智能录入",
        from: "orgInfo" }, {
        name: "其他信息",
        path: "/bizFlow/:busiCode/:userType/baseInfoNode/bizEntry/40",
        group: "OTHER_INFO_PAGE",
        modules: ["LINK_MODULE", "LEGAL_MODULE", "AGENT_LINK_MODULE", "PARTNER_MODULE"],
        mdMaxLen: 10,
        fromName: "智能录入",
        from: "orgInfo"
      }, {
        name: "控制人信息",
        path: "/bizFlow/:busiCode/:userType/baseInfoNode/bizEntry/50",
        group: "CONTROLER_INFO_PAGE",
        modules: ["CONTROLER_MODULE1", "CONTROLER_MODULE", "BENEFICIARY_MODULE"],
        mdMaxLen: 10,
        fromName: "机构信息",
        from: "orgInfo"
      }, {
        name: "涉税信息",
        path: "/bizFlow/:busiCode/:userType/baseInfoNode/bizEntry/60",
        group: "TAX_INFO",
        modules: ["CREDIT_INFO", "MA_CUST_TAX_INFO_MODULE", "MA_CONTROLER_TAX_INFO_MODULE"],
        mdMaxLen: 10,
        fromName: "机构信息",
        from: "orgInfo"
      }, {
        name: "账户信息",
        path: "/bizFlow/:busiCode/:userType/baseInfoNode/bizEntry/70",
        group: "ACCT_INFO",
        modules: ["TRDACCT_MODULE", "BSB_MODULE", "ASSET_MODULE"],
        fromName: "机构信息",
        from: "orgInfo"
      }, {
        name: "影像上传",
        path: "/bizFlow/:busiCode/:userType/imageUploadNode/bizPage/QS420_uploadImg",
        isApptRoute: false,
        from: "imageUploadNode"
      }, {
        name: "流程详情",
        path: "/bizFlow/:busiCode/:userType/imageUploadNode/bizPage/QS420_progress",
        isApptRoute: false,
        from: "imageUploadNode",
        ignorePrev: true,
        isShowPrev: false,
        isShowNext: false
      }, {
        name: "表单打印",
        path: "/bizFlow/:busiCode/:userType/formPrintNode/bizPage/QS420_formPrint",
        isApptRoute: false,
        from: "formPrintNode"
      }, {
        name: "账户密码设置",
        path: "/bizFlow/:busiCode/:userType/acctPwdInfoNode/bizEntry/80",
        group: "PASSWORD_INFO",
        modules: ["AGENT_PHONE_MODULE", "PASSWORD_MODULE"],
        fromName: "账户密码设置"
      }, {
        name: "见证双录",
        isApptRoute: false,
        path: "/bizFlow/:busiCode/:userType/videoWitnessInfoNode/bizPage/QS420_mobile_video_witness"
      }, {
        name: "上传表单",
        path: "/bizFlow/:busiCode/:userType/formUploadNode/bizPage/QS420_uploadForm",
        from: "formUploadNode"
      }, {
        name: "终审流程详情",
        path: "/bizFlow/:busiCode/:userType/formUploadNode/bizPage/QS420_progress",
        isApptRoute: false,
        from: "formUploadNode",
        ignorePrev: true,
        isShowPrev: false,
        isShowNext: false
      }]
    },

    "QS421": {
      open: true,
      pageCount: 20,
      infoList: [{
        "id": "2",
        "type": "ID_TYPE",
        "name": "产品",
        "explain": "本功能适用于为您办理产品客户开户业务",
        "list": orgCommonList.concat([])
      }],
      bizRoutes: [{
        name: "产品信息",
        path: "/bizFlow/:busiCode/:userType/baseInfoNode/bizEntry/10",
        group: "OCR_ORG_INFO_PAGE",
        modules: ["IMPORTANT_MODULE_OCR", "IMPORTANT_MODULE_ZD", "ZD_MODULE", "IMPORTANT_MODULE"],
        fromName: "资料录入",
        from: "orgInfo" }, {
        name: "代理人信息",
        path: "/bizFlow/:busiCode/:userType/baseInfoNode/bizEntry/20",
        group: "OCR_AGENT_INFO_PAGE",
        modules: ["AGENT_MODULE_OCR", "AGENT_MODULE"],
        fromName: "智能录入",
        from: "orgInfo" }, {
        name: "基础信息",
        path: "/bizFlow/:busiCode/:userType/baseInfoNode/bizEntry/30",
        group: "PRODUCT_INFO_PAGE",
        modules: ["BASE_INFO"],
        fromName: "智能录入",
        from: "orgInfo" }, {
        name: "管理人信息",
        path: "/bizFlow/:busiCode/:userType/baseInfoNode/bizEntry/40",
        group: "MANAGER_INFO_PAGE",
        modules: ["MANAGER_OTHER_INFO"],
        fromName: "智能录入",
        from: "orgInfo"
      }, {
        name: "其他信息",
        path: "/bizFlow/:busiCode/:userType/baseInfoNode/bizEntry/45",
        group: "OTHER_INFO_PAGE",
        modules: ["LINK_MODULE", "LEGAL_MODULE", "AGENT_LINK_MODULE"],
        mdMaxLen: 10,
        fromName: "智能录入",
        from: "orgInfo"
      }, {
        name: "控制人信息",
        path: "/bizFlow/:busiCode/:userType/baseInfoNode/bizEntry/50",
        group: "CONTROLER_INFO_PAGE",
        modules: ["CONTROLER_MODULE1", "CONTROLER_MODULE", "CONTROLER_MODULE2", "BENEFICIARY_MODULE", "BENEFICIARY_MODULE_1", "BENEFICIARY_MODULE_0", "BENEFICIARY_MODULE_2", "BENEFICIARY_MODULE_3", "BENEFICIARY_MODULE_4"],
        mdMaxLen: 10,
        fromName: "机构信息",
        from: "orgInfo"
      }, {
        name: "涉税信息",
        path: "/bizFlow/:busiCode/:userType/baseInfoNode/bizEntry/60",
        group: "TAX_INFO",
        modules: ["CREDIT_INFO", "MA_CUST_TAX_INFO_MODULE", "MA_CONTROLER_TAX_INFO_MODULE"],
        mdMaxLen: 10,
        fromName: "机构信息",
        from: "orgInfo"
      }, {
        name: "托管人信息",
        path: "/bizFlow/:busiCode/:userType/baseInfoNode/bizEntry/65",
        group: "OTHER_INFO_PAGE",
        modules: ["PRO_TRUSTEE_INFO", "PRO_ORD_INFO", "INVEST_INFO", "SHAREREG_INFO"],
        mdMaxLen: 10,
        fromName: "机构信息",
        from: "orgInfo"
      }, {
        name: "账户信息",
        path: "/bizFlow/:busiCode/:userType/baseInfoNode/bizEntry/70",
        group: "ACCT_INFO",
        modules: ["TRDACCT_MODULE", "BSB_MODULE", "ASSET_MODULE"],
        fromName: "机构信息",
        from: "orgInfo"
      }, {
        name: "权限开通",
        path: "/bizFlow/:busiCode/:userType/baseInfoNode/bizPage/agmtInfo",
        fromName: "机构信息",
        from: "orgInfo"
      }, {
        name: "影像上传",
        path: "/bizFlow/:busiCode/:userType/imageUploadNode/bizPage/QS421_uploadImg",
        isApptRoute: false,
        from: "imageUploadNode"
      }, {
        name: "流程详情",
        path: "/bizFlow/:busiCode/:userType/imageUploadNode/bizPage/QS421_progress",
        isApptRoute: false,
        from: "imageUploadNode",
        ignorePrev: true,
        isShowPrev: false,
        isShowNext: false
      }, {
        name: "表单打印",
        path: "/bizFlow/:busiCode/:userType/formPrintNode/bizPage/QS421_formPrint",
        isApptRoute: false,
        from: "formPrintNode"
      }, {
        name: "账户密码设置",
        path: "/bizFlow/:busiCode/:userType/acctPwdInfoNode/bizEntry/80",
        group: "PASSWORD_INFO",
        modules: ["AGENT_PHONE_MODULE", "PASSWORD_MODULE"],
        fromName: "账户密码设置"
      }, {
        name: "见证双录",
        isApptRoute: false,
        path: "/bizFlow/:busiCode/:userType/videoWitnessInfoNode/bizPage/QS421_mobile_video_witness"
      }, {
        name: "上传表单",
        path: "/bizFlow/:busiCode/:userType/formUploadNode/bizPage/QS421_uploadForm",
        from: "formUploadNode"
      }, {
        name: "终审流程详情",
        path: "/bizFlow/:busiCode/:userType/formUploadNode/bizPage/QS421_progress",
        isApptRoute: false,
        from: "formUploadNode",
        ignorePrev: true,
        isShowPrev: true,
        isShowNext: false
      }]
    }
  }
};

var plugin = {
  install: function install(Vue) {
    Vue.qsConfig = qsConfig;

    Vue.prototype.$qsConfig = qsConfig;
  },

  $qsConfig: qsConfig
};

export default plugin;
export var install = plugin.install;


//////////////////
// WEBPACK FOOTER
// ./src/business/businessConfig/qsVersionConfig/qsGuoTouConfig.js
// module id = 934
// module chunks = 2